// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".justdialv2-container[data-v-5eb050de]{background-color:var(--v-background-base,#f5f5f5);min-height:100vh}.theme--dark .justdialv2-container[data-v-5eb050de]{background-color:#121212!important}.integration-label[data-v-5eb050de]{font-size:14px;font-weight:700}.integration-value[data-v-5eb050de]{font-size:16px}.integration-title[data-v-5eb050de]{font-size:24px;font-weight:700}.integration-body[data-v-5eb050de]{padding:20px}.integration-textarea[data-v-5eb050de]{min-height:80px}", ""]);
// Exports
module.exports = exports;
